import randomUUID from '@/utils/uuid'
import Storage from '@/storage'

const storage = new Storage()

const AI_ATTACHMENT_PREFIX = 'ai-attachments'

export const uploadAiAttachment = async ({ projectId, workflowId, file, mimeType }) => {
  const id = randomUUID()
  const s3Key = `${AI_ATTACHMENT_PREFIX}/${projectId}/${workflowId}/${id}/${file.name}`
  await storage.uploadFile(s3Key, file)

  return {
    s3Key,
    name: file.name,
    mimeType,
    size: file.size
  }
}

export const deleteAiAttachment = async (s3Key) => {
  await storage.deleteFile(s3Key)
}
